export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-csgo-9927319f1f25b1abbfc27fdb766ede1d.webm";